import { ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../api/api.service";
import store from "../../../store/store.module";
import { GET_INVENTORY_DETAIL_REQUESTED } from "./detail.action";

@Component({
  selector: "app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.scss"]
})
export class DetailComponent implements OnInit {
  public store = store;
  constructor(private api: ApiService, private route: ActivatedRoute) {}

  ngOnInit() {
    let sku = this.route.snapshot.paramMap.get("id");
    store.dispatch({ type: GET_INVENTORY_DETAIL_REQUESTED, data: sku });
  }
}
